import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token : null
  },
  mutations: {
    tokenFunc (state,token) {
      console.log(token)
      state.token = token;
      window.localStorage.setItem('token',state.token);
    }
  },
  actions: {
    token ({commit},token) {
      commit('tokenFunc',token)
    }
  }
});
